
import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSelect from "Common/Custom/FormSelect";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { getSelectOptions } from "utils/optionHelper";


const AddDivisionForm = ({
    fields,
    values,
    errors,
    departments,
    handleChange,
    handleSubmit,
    loading,
    title
}) => {
    const optionConfig = {
        department_id: {
            list: departments,
            valueKey: "department_id",
            labelKey: "department_name"
        },
    };
    return (
        <PageBody onSubmit={handleSubmit} headerchildren={
            <HeadingOne>{title}</HeadingOne>
        }>
            {fields.map((field) => {
                if (field.type === "select") {
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            options={getSelectOptions(field.name, optionConfig)}
                            error={errors[field.name]}
                        />
                    );
                }

                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Save"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default AddDivisionForm;
